// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__n7Cc3","actionsCol":"EnrolledClinics_actionsCol__2BFFR"};